export default function markerRenderFunction(markerData) {
  const htmlStr = `
    <table width="50" height="44">
      <tr>
        <td class="text-center">
          <b>${markerData.title}</b>
        </td>
      </tr>
      <tr>
        <td class="text-center ${markerData.classes}">
          <span>${markerData.value} ${markerData.unit}</span>
        </td>
      </tr>
    </table>
    `;

  return {
    html: htmlStr,
    size: [50, 44]
  };
}